
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"96","height":"96","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#56BDD2","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M48 0C21.533 0 0 21.534 0 48c0 26.467 21.533 48 48 48 26.468 0 48-21.533 48-48C96 21.534 74.468 0 48 0zm0 88.091c-22.107 0-40.091-17.984-40.091-40.09C7.909 25.893 25.893 7.908 48 7.908S88.09 25.894 88.09 48c0 22.107-17.983 40.091-40.09 40.091z"}}),_c('path',{attrs:{"d":"M52.147 46.103V18.95c0-2.181-1.824-3.95-4.074-3.95S44 16.769 44 18.95v28.722c0 1.227.588 2.307 1.49 3.032.039.045.065.095.105.139L60.87 67.662A4.127 4.127 0 0063.93 69c.954 0 1.916-.323 2.69-.986a3.868 3.868 0 00.365-5.575L52.147 46.103z"}})])])
          )
        }
      }
    